var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavInvoiceBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Invoice",
    d: "M367-439.5A11.5,11.5,0,0,1,378.5-451,11.5,11.5,0,0,1,390-439.5,11.5,11.5,0,0,1,378.5-428,11.5,11.5,0,0,1,367-439.5Zm1.7,0a9.811,9.811,0,0,0,9.8,9.8,9.811,9.811,0,0,0,9.8-9.8,9.811,9.811,0,0,0-9.8-9.8A9.811,9.811,0,0,0,368.7-439.5Zm9.247,6.962v-1.681H375a.85.85,0,0,1-.85-.85.849.849,0,0,1,.85-.85h2.948v-2.731h-.733a3.068,3.068,0,0,1-3.065-3.065,3.067,3.067,0,0,1,3.065-3.064h.733v-1.682a.849.849,0,0,1,.85-.85.85.85,0,0,1,.85.85v1.682h2.315a.849.849,0,0,1,.85.85.849.849,0,0,1-.85.85h-2.315v2.731h.733a3.069,3.069,0,0,1,3.064,3.065,3.069,3.069,0,0,1-3.064,3.065h-.733v1.681a.85.85,0,0,1-.85.85A.85.85,0,0,1,377.948-432.538Zm1.7-3.381h.733a1.367,1.367,0,0,0,1.364-1.365,1.367,1.367,0,0,0-1.364-1.365h-.733Zm-3.8-5.8a1.367,1.367,0,0,0,1.365,1.365h.733v-2.731h-.733A1.367,1.367,0,0,0,375.85-441.716Z",
    transform: "translate(-367 451)",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavInvoiceBlack);
export default __webpack_public_path__ + "static/media/Nav-InvoiceBlack.40ccfc2fff944bdf5b60d510bdb6cfa1.svg";
export { ForwardRef as ReactComponent };